/* ============================================================
   Season ticker — picks the active season from the VISITOR's date
   (client-side, so it always reflects the current season), or from
   the pinned "force season" setting in the theme editor.

     Spring  Mar 1 – May 31  (months 2–4)
     Summer  Jun 1 – Aug 31  (months 5–7)
     Autumn  Sep 1 – Nov 30  (months 8–10)
     Winter  Dec 1 – Feb 28  (months 11, 0, 1)

   Marquee pauses on hover/touch; reduced-motion users get static text.
   ============================================================ */
(function () {
  'use strict';

  function seasonFromDate(d) {
    var m = d.getMonth();
    if (m >= 2 && m <= 4) return 'spring';
    if (m >= 5 && m <= 7) return 'summer';
    if (m >= 8 && m <= 10) return 'autumn';
    return 'winter';
  }

  function initTicker(root) {
    var cfgEl = root.querySelector('[data-season-config]');
    if (!cfgEl) return;
    var cfg;
    try {
      cfg = JSON.parse(cfgEl.textContent);
    } catch (e) {
      return;
    }
    var forced = root.getAttribute('data-force-season') || 'auto';
    var season = (forced && forced !== 'auto') ? forced : seasonFromDate(new Date());
    if (!cfg[season]) season = 'autumn';

    var link = root.querySelector('[data-season-link]');
    var track = root.querySelector('[data-season-track]');
    if (!link || !track) return;

    var text = cfg[season].text || '';
    var url = cfg[season].url || '#';
    link.setAttribute('href', url);
    link.setAttribute('aria-label', text);

    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    track.textContent = '';
    if (reduceMotion) {
      track.classList.add('is-static');
      var single = document.createElement('span');
      single.className = 'season-ticker-item';
      single.textContent = text;
      track.appendChild(single);
      return;
    }

    /* 8 identical items; CSS translates the track -50% for a seamless loop */
    for (var i = 0; i < 8; i++) {
      var sp = document.createElement('span');
      sp.className = 'season-ticker-item';
      sp.setAttribute('aria-hidden', i > 0 ? 'true' : 'false');
      sp.textContent = text;
      track.appendChild(sp);
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-season-ticker]');
    for (var i = 0; i < roots.length; i++) {
      initTicker(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
